import { useCallback } from "react";
import { useTranslate } from "hooks";

export const useRenderProjectsShowing = () => {
  const translate = useTranslate();

  const renderProjectsShowing = useCallback(
    (currentPageNo, totalCount, itemsPerPage) => {
      const startNumber =
        currentPageNo === 1 ? 1 : (currentPageNo - 1) * itemsPerPage;
      const endNumber = Math.min(currentPageNo * itemsPerPage, totalCount);

      const output = `${translate("PROJECT_LIST_SHOWING")} ${startNumber} - ${endNumber} ${translate("PROJECT_LIST_OF")} ${totalCount}`;

      return totalCount ? output : null;
    },
    [translate],
  );

  return renderProjectsShowing;
};
